import React from 'react'
import PackageIcon from '../assets/icons/white-box.svg'
import CheckIcon from '@material-ui/icons/Check'
import PriorityHigh from '@material-ui/icons/PriorityHigh'
import LocalShippingRoundedIcon from '@material-ui/icons/LocalShippingRounded'
import {
    eventTypes,
    getObjectKey,
    entryTypeIds,
    reservationStates,
    courierParcelEventTypeIds,
    externalHaulerStates
} from '../server/shared'
import { strings } from '../localization/strings'

/*
const okStyles = {backgroundColor: "green",icon:  <CheckIcon style={{height:24,width:24}} />};
const neutralStyles = {backgroundColor: "rgb(33, 150, 243)",icon: <img style={{height:24,width:24,margin: "auto",display: "block",marginTop: 8}} src={PackageIcon} alt={"icon"}/>};
const warningStyles = {backgroundColor: "red",icon:  <ErrorIcon style={{height:24,width:24}} />};

*/
/*
const okStyles = {backgroundColor: "#f7b500",icon:  <CheckIcon style={{height:24,width:24}} />};
const neutralStyles = {backgroundColor: "rgb(33, 150, 243)",icon: <img style={{height:24,width:24,margin: "auto",display: "block",marginTop: 8}} src={PackageIcon} alt={"icon"}/>};
const warningStyles = {backgroundColor: "#af2022",icon:  <ErrorIcon style={{height:24,width:24}} />};
*/

const okStyles = {
    backgroundColor: '#12b804',
    icon: <CheckIcon style={{ height: 24, width: 24 }} />,
}
const neutralStyles = {
    backgroundColor: 'rgb(33, 150, 243)',
    icon: (
        <img
            style={{
                height: 24,
                width: 24,
                margin: 'auto',
                display: 'block',
                marginTop: 8,
            }}
            src={PackageIcon}
            alt={'icon'}
        />
    ),
}
const warningStyles = {
    backgroundColor: '#af2022',
    icon: <PriorityHigh style={{ height: 24, width: 24 }} />,
}

const externalHaulerStyles = {
    backgroundColor: '#256e7c',
    icon: <LocalShippingRoundedIcon style={{ height: 24, width: 24 }} />,
}

// Devuelve array con ---> 0: style, 1: title, 2: message, 3: date

const eventTypes_ok = [
    eventTypes.reservationConfirmed,
    eventTypes.reservationCollected,
    eventTypes.reservationDeposited,
    eventTypes.reservationPickupCompleted,
    eventTypes.reservationExtended,
    eventTypes.securityTokenValid,
]

const eventTypes_neutral = [
    eventTypes.reservationAbandonedCollected,
    eventTypes.reservationCollectedByTechnician,
    eventTypes.reservationCancelledCollected,
    eventTypes.reservationCancelledPickupCompleted,
    eventTypes.recoverReservationRequest,
    eventTypes.recoverReservationResult,
    eventTypes.securityTokenGenerated,
]

const eventTypes_warning = [
    eventTypes.reservationAbandoned,
    eventTypes.reservationDepositAbandoned,
    eventTypes.reservationPickupExpired,
    eventTypes.reservationPickupTimerExpiresSoon,
    eventTypes.reservationDepositExpired,
    eventTypes.reservationDepositTimerExpiresSoon,
    eventTypes.reservationPickupInvalidSecurityCode,
    eventTypes.incidence,
    eventTypes.depositOrPickupFailed,
    eventTypes.reservationCancelled,
    eventTypes.reservationCancelledPickupExpired,
    eventTypes.reservationCancelledPickupWhenNotIdle,
    eventTypes.reservationCancelledPickupDoorLocked,
    eventTypes.reservationCancelledPickupPackageMissing,
    eventTypes.reservationCancelledPickupDoorOpenedAndPackageNotFound,
    eventTypes.reservationCancelledPickupDoorOpenedAndPackageFound,
    eventTypes.recoverReservationRequest,
    eventTypes.recoverReservationResult,
    eventTypes.securityTokenInvalid,
]

const reservationStates_ok = [
    reservationStates.new,
    reservationStates.confirmed,
    reservationStates.deposited,
    reservationStates.reservationPickupCompleted,
    reservationStates.collected,
]

const reservationStates_neutral = [
    reservationStates.canceledDeposited,
    reservationStates.canceledDepositedCollected,
]

const reservationStates_warning = [
    reservationStates.canceled,
    reservationStates.expiredNotConfirmed,
    reservationStates.expiredNotDeposited,
    reservationStates.expiredNotCollected,
    reservationStates.abandonedCollected,
    reservationStates.abandoned,
    reservationStates.canceledParcelMissing,
]

const courierParcelOkEventIds = [
    courierParcelEventTypeIds.created,
    courierParcelEventTypeIds.markedForPickUp,
    courierParcelEventTypeIds.arrivalAtFacility,
    courierParcelEventTypeIds.reserved,
    courierParcelEventTypeIds.waitingReservation,
    courierParcelEventTypeIds.waitingCourierConfirmation,
    courierParcelEventTypeIds.parcelPickUp,
    courierParcelEventTypeIds.inTransit,
    courierParcelEventTypeIds.delivered,
    courierParcelEventTypeIds.departureFromFacility,
    courierParcelEventTypeIds.outForDelivery,
    courierParcelEventTypeIds.courierDeliver,
    courierParcelEventTypeIds.lockerPickup,
]

const courierParcelNeutralEventIds = [
    courierParcelEventTypeIds.addressEditByCourier,
]

const courierParcelWarningEventIds = [
    courierParcelEventTypeIds.expired,
    courierParcelEventTypeIds.cancelled,
    courierParcelEventTypeIds.waitingIncidenceResolution,
    courierParcelEventTypeIds.deliverAttempt,
    courierParcelEventTypeIds.returnToSender,
    courierParcelEventTypeIds.pickupAttempt,
    courierParcelEventTypeIds.unableToPickup,
]

//[style, title, message, date
export const getEventInfo = (event) => {
    if (!event) return [warningStyles, strings.noMessageForEvent]

    if (event.entryTypeId === entryTypeIds.courierEvent && event.typeId) {
        let info = []

        if (courierParcelOkEventIds.includes(event.typeId)) {
            info[0] = okStyles
        } else if (courierParcelNeutralEventIds.includes(event.typeId)) {
            info[0] = neutralStyles
        } else if (courierParcelWarningEventIds.includes(event.typeId)) {
            info[0] = warningStyles
        } else {
            info[0] = warningStyles
        }

        info[1] =
            strings.courierParcelEventTypes[
                getObjectKey(courierParcelEventTypeIds, event.typeId)
            ]
        info[3] = event.timeStamp
        return info
    }

    if (event.entryTypeId === entryTypeIds.reservationEvent && event.typeId) {
        let info = []

        if (eventTypes_ok.includes(event.typeId)) {
            info[0] = okStyles
        } else if (eventTypes_neutral.includes(event.typeId)) {
            info[0] = neutralStyles
        } else if (eventTypes_warning.includes(event.typeId)) {
            info[0] = warningStyles
        } else {
            info[0] = warningStyles
        }

        info[1] = strings.eventTypes[getObjectKey(eventTypes, event.typeId)]
        info[3] = event.timeStamp
        return info
    }

    if (event.entryTypeId === entryTypeIds.externalHauler && event.typeId) {
        let info = []
        info[0] = externalHaulerStyles      
        info[1] = strings.externalHaulerStates[getObjectKey(externalHaulerStates, event.typeId)]
        info[3] = event.timeStamp
        return info
    }

    if (event.lastStateId) {
        let info = []

        if (reservationStates_ok.includes(event.LastStateId)) {
            info[0] = okStyles
        } else if (reservationStates_neutral.includes(event.LastStateId)) {
            info[0] = neutralStyles
        } else if (reservationStates_warning.includes(event.LastStateId)) {
            info[0] = warningStyles
        } else {
            info[0] = warningStyles
        }
        info[1] =
            strings.reservationStates[
                getObjectKey(reservationStates, event.LastStateId)
            ]
        info[3] = event.InsertionTS
        return info
    }

    return [warningStyles, strings.noMessageForEvent, event.ErrorResult]
}
